
import { useDispatch } from 'react-redux';
import { login } from '../../services/backend_user_auth_service';
import { loginValidation } from '../../validations/loginValidation';


const initialValues = {
    email: '',
    password: ''
};

const Login = () => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const handleLogin = async (values) => {

        try {
            setLoading(true);
            const accessToken = await dispatch(login(values.email, values.password));

            if (accessToken) {
                setLoading(false);
                navigate('/home');
            }
        } catch (error) {

            setLoading(false);
            toast.error(error.message, toastOptions)
            // Handle login error
        } finally {
            setLoading(false);
        }
    };





    return (
        <Container fluid className="d-flex align-items-center justify-content-center min-vh-100 radial-gradient">
            <Row className="justify-content-center w-100">
                <Col md={8} lg={6} xxl={3}>
                    <Card className="mb-0">
                        <Card.Body>
                            <Link to="/" className="text-center d-block py-3 w-100">
                                <h2>Aegis Admin</h2>
                            </Link>
                            <p className="text-center">Log in to your dashboard</p>
                            <Formik
                                initialValues={initialValues}
                                validationSchema={loginValidation}
                                onSubmit={(values) => {
                                    handleLogin(values);
                                }}
                            >
                                {({ errors }) => (
                                    <Form>
                                        <BootstrapForm.Group className="mb-3" controlId="email">
                                            <BootstrapForm.Label>Email</BootstrapForm.Label>
                                            <Field name="email">
                                                {({ field }) => (
                                                    <BootstrapForm.Control
                                                        type="email"
                                                        isInvalid={!!errors.email}
                                                        {...field}
                                                    />
                                                )}
                                            </Field>
                                            <BootstrapForm.Control.Feedback type="invalid">
                                                {errors.email}
                                            </BootstrapForm.Control.Feedback>
                                        </BootstrapForm.Group>
                                        <BootstrapForm.Group className="mb-4" controlId="password">
                                            <BootstrapForm.Label>Password</BootstrapForm.Label>
                                            <Field name="password">
                                                {({ field }) => (
                                                    <BootstrapForm.Control
                                                        type="password"
                                                        isInvalid={!!errors.password}
                                                        {...field}
                                                    />
                                                )}
                                            </Field>
                                            <BootstrapForm.Control.Feedback type="invalid">
                                                {errors.password}
                                            </BootstrapForm.Control.Feedback>
                                        </BootstrapForm.Group>
                                        <div className="d-flex align-items-center justify-content-between mb-4">
                                            <Link to="/forgotPassword" className="text-primary fw-bold">
                                                Forgot password? Reset Password
                                            </Link>
                                        </div>
                                        <Button
                                            variant="primary"
                                            type="submit"
                                            className="w-100 py-3 mb-4"
                                        >
                                            {loading ? 'Loading...' : 'Sign In'}
                                        </Button>

                                    </Form>
                                )}
                            </Formik>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

        </Container>
    );
};

export default Login;
